import React from 'react';
import PropTypes from 'prop-types';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import CollapsiblePanelContainer from './../Containers/CollapsiblePanelContainer';
import ArtifactHealthApplicationContainer
  from './../Containers/ArtifactHealthApplicationContainer';
import ArtifactHealthIcon from './ArtifactHealthIcon';
import { artifactHealth, annotation } from './../helpers';

const ArtifactHealthApplicationsComponent = ({
  platform,
  appStatuses,
  annotations,
  showCommentHistory
}) => (
  <div>
    {
      appStatuses.map((appStatus, i) => {
        const status = artifactHealth.getArtifactHealthStatusByCode(appStatus.status);
        const annotationCount = annotations[appStatus.id] &&
          annotations[appStatus.id].length;
        const tooltip = (
          <Tooltip id="tooltip" style={{ width: 'auto' }}>
            {annotationCount} comment{annotationCount > 1 ? 's' : null}
          </Tooltip>
        );
        const glyph = annotation.getAnnotationGlyphFromList(annotations, appStatus.id) ||
          'question-sign';

        return (
          <CollapsiblePanelContainer
            title={
              <div style={{ display: 'flex' }}>
                <div style={{ flexGrow: 1 }}>{appStatus.name}</div>
                {annotationCount ?
                  (<OverlayTrigger overlay = {tooltip} placement="top" delayShow={125}>
                    <span role="button"
                      onClick={() => showCommentHistory(appStatus)}
                    >
                      <ArtifactHealthIcon
                        symbol={glyph}
                        color={'black'}
                      />
                    </span>
                  </OverlayTrigger>) : null}
                <ArtifactHealthIcon
                  symbol={status.symbol}
                  color={status.color}
                />
              </div>
            }
            key={i}
          >
            <ArtifactHealthApplicationContainer
              appSupportId={appStatus.id}
              platform={platform}
              applicationName={appStatus.name}
              status={appStatus.status}
            />
          </CollapsiblePanelContainer>
        );
      })
    }
  </div>
);

ArtifactHealthApplicationsComponent.propTypes = {
  platform: PropTypes.string.isRequired,
  appStatuses: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    status: PropTypes.number.isRequired
  })).isRequired,
  annotations: PropTypes.object.isRequired,
  showCommentHistory: PropTypes.func.isRequired
};

export default ArtifactHealthApplicationsComponent;


// WEBPACK FOOTER //
// src/Components/ArtifactHealthApplicationsComponent.jsx